import { FC, useState } from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import CustomButton from "ui/Button";
import { ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import CustomDropDownList from "ui/dropDown";
import { getBuyersFilterApi } from "api/common";
import { Vessel } from "interface/vessel";
import { ReleasedPackageFilter } from "api/releasedPackage";
import { getVesselFilter } from "api/vessel";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: ReleasedPackageFilter) => void;
	filterOptions: ReleasedPackageFilter;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	...props
}) => {
	const { t } = useTranslation();
	const [tempFilter, setTempFilter] = useState(filterOptions);

	const applyRegistrationId = () => {
		setFilterOptions({
			...filterOptions,
			// vesselLedgerAccountNumber: tempFilter.settlementNumber,
			registrationId: tempFilter.registrationId,
			take: props.pageSize,
			skip: 0,
		});
	};

	const registrationIdValue =
		tempFilter.registrationId == null || tempFilter.registrationId === ""
			? null
			: Number(tempFilter.registrationId);

	return (
		<div className="filter-container">
			<div className="filter-items released-package-filter-items">
				<div className="released-package-filter-field" style={{ width: "170px" }}>
					<NumericTextBox
						className="height-inherit released-package-registration-input"
						label={t("RegistrationId")}
						placeholder=" "
						style={{ width: "100%" }}
						value={Number.isNaN(registrationIdValue) ? null : registrationIdValue}
						onChange={(e) =>
							setTempFilter({
								...tempFilter,
								registrationId: e.value == null ? undefined : String(e.value),
							})
						}
						onKeyDown={(e: any) => {
							if (e.key === "Enter") applyRegistrationId();
						}}
						onBlur={() => applyRegistrationId()}
						spinners={false}
						format=""
					/>
				</div>
				<div className="released-package-filter-field" style={{ width: "170px" }}>
					<CustomDropDownList
						onSelect={(buyer) =>
							setFilterOptions({
								...filterOptions,
								buyerName: buyer.name,
								buyerLedgerAccountNumber: buyer.id,
								take: props.pageSize,
								skip: 0,
							})
						}
						data={[]}
						value={{
							id: filterOptions.buyerLedgerAccountNumber || null,
							//	name: filterOptions.buyerName || t("ChooseBuyer"),
							name: filterOptions.buyerName || " ",
						}}
						dataItemKey="id"
						textField="name"
						label={t("Buyer")}
						defaultItem={{ id: null, name: t("All") }}
						className="height-inherit"
						filterable={true}
						serverFilter={true}
						serverFilterApi={getBuyersFilterApi}
					/>
				</div>
				<div className="released-package-filter-field" style={{ width: "170px" }}>
					<CustomDropDownList
						data={[]}
						filterable={true}
						dataItemKey="id"
						textField="nm"
						label={t("Vessel")}
						value={{
							id: filterOptions.vesselId || null,
							//	nm: filterOptions.vesselName || t("ChooseVessel"),
							nm: filterOptions.vesselName || " ",
						}}
						// label="Velg Fartøy"
						defaultItem={{ id: null, nm: t("All") }}
						onSelect={(vessel: Vessel) => {
							setFilterOptions({
								...filterOptions,
								vesselId: vessel.id,
								vesselName: vessel.id ? vessel.nm : "",
								vesselRegistrationId: vessel.rn as any,
								take: props.pageSize,
								skip: 0,
							});
						}}
						serverFilter={true}
						serverFilterApi={getVesselFilter}
						// popupSettings={{ width: 400 }}
					/>
				</div>
			</div>

			<div className="filter-end-btn released-package-filter-end-btn">
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
